import {JsonObject} from "../../shared/json/json-object";
import {JsonProperty} from "../../shared/json/json-property";

@JsonObject()
export abstract class GameBoard {

  ineligible: boolean = false;

  abstract getPoints(duration: number): number;

  abstract toJSON(): any;
}

@JsonObject()
export class GamePlayKey  {

  constructor(@JsonProperty() readonly gameId: string, @JsonProperty() readonly gamePlayId: string) {
  }
}

@JsonObject()
export abstract class GamePlayers {
}

@JsonObject()
export class GameSetup {

  constructor(@JsonProperty() readonly key: GamePlayKey, @JsonProperty() readonly players?: GamePlayers) {
  }
}

@JsonObject()
export class GamePlay {

  private finishOffset: number;

  constructor(readonly setup: GameSetup, readonly created: number, startOffset: number, updateOffset: number, finishOffset: number, readonly jsonData: any) {
    this.finishOffset = finishOffset;
  }

  isFinished(): boolean {
    return this.finishOffset > 0;
  }

  finish() {
    this.finishOffset = Math.max(1, Date.now() - this.created);
  }

  getDuration(): number {
    return this.finishOffset;
  }
}

export abstract class GameConfig {

  protected constructor(readonly players?: GamePlayers) {
  }
}

export abstract class GameData<V> {

  constructor(readonly gamePlay: GamePlay) {
  }

  getDuration(): number {
    return this.gamePlay.getDuration();
  }
}

export abstract class GameSettings {

}

export abstract class Game<T extends GameConfig, V extends GameData<any>, S extends GameSettings> {

}

export enum GameOverResultType {
  WON,
  LOST,
  OTHER,
}

export class GameOverResult {

  constructor(readonly gameId: string, readonly type: GameOverResultType, readonly level: string, readonly points: number, readonly duration: number, readonly resultText?: string, readonly ineligible?: boolean) {
  }
}